import { recordPrice } from '@/api/mifid/recordPrice.ts';
import { webapi } from '@/api/webapi.ts';

export const mifidApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    recordPrice: recordPrice(builder),
  }),
});

export const { useRecordPriceMutation } = mifidApi;
